// engine
import { ArController } from '@aceroll/core';

import { platform } from '../../platform';

// services
import { autoplayService } from '../../services/autoplay-service';
import { gameSoundService } from '../../services/game-sound-service';
import { winAnimationService } from '../../services/win-animation-service';

export class idle extends ArController {
	onStart() {
		if (!this._initial) {
			this._initial = true;
			gameSoundService.subscribeUISounds();
			gameSoundService.setBaseAmbient(1500);
		}

		// if (gameSoundService.levelPlaying) {
		// 	gameSoundService.levelPlaying = false;
		// 	gameSoundService.setBaseAmbient(750);
		// }

		if (autoplayService.started) {
			this.stop();
			return;
		}

		platform.onceRoundStarted()
			.then(() => {


				this.stop();
			});
	}
	onStop() {
		//to stop sycle aniation if any
		winAnimationService.stopWinCycle();
	}
}
